import React from "react";
import { Facebook, Github, Instagram, Linkedin, Music2, Twitter, Youtube } from "lucide-react";
import { activeSocialProfiles } from "../data/socialLinks";

const icons = {
  instagram: Instagram,
  tiktok: Music2,
  facebook: Facebook,
  x: Twitter,
  youtube: Youtube,
  linkedin: Linkedin,
  github: Github,
};

const SocialLinks = ({ className = "", testIdPrefix = "social" }) => (
  <div className={`flex flex-wrap items-center gap-2 ${className}`} data-testid={`${testIdPrefix}-links`}>
    {activeSocialProfiles.map(({ id, label, handle, url }) => {
      const Icon = icons[id];
      return (
        <a
          key={id}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${label}${handle ? ` — ${handle}` : ""}`}
          title={`${label}${handle ? ` — ${handle}` : ""}`}
          data-testid={`${testIdPrefix}-${id}-link`}
          className="h-11 w-11 inline-flex items-center justify-center rounded-md border border-[#1E90FF]/20 text-[#A1A7B3] hover:border-[#1E90FF]/60 hover:text-[#1E90FF] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F3F6FA] focus-visible:ring-offset-2 focus-visible:ring-offset-[#05070B] transition-colors"
        >
          {id === "x" ? <span aria-hidden="true" className="text-sm font-semibold">X</span> : <Icon size={18} aria-hidden="true" />}
          <span className="sr-only">{label}</span>
        </a>
      );
    })}
  </div>
);

export default SocialLinks;